import ScoreLineChart from '../../../Charts/ScoreLineChart';

export default {
    name: 'assessment-details',
    components: {
        ScoreLineChart
    },
    props: {
        questionnaire: Object,
        topics: Array,
        completed: Boolean
    },
    data() {
        return {
            scoreChartData: this.getDefaultScoreChartData(),
            dataLoaded: false
        }
    },
    computed: {
        questionnaireScore() {
            return this.questionnaire.scoreDefinition ? (this.questionnaire.scoreDefinition.score || 0) : 0;
        },

        questionnaireScoreDefinition() {
            return this.$scoreService.getDescriptionByScore(this.questionnaireScore);
        }
    },
    mounted() {
        this.loadScoresData();
    },
    methods: {
        async loadScoresData() {
            let self = this,
                currentDate = new Date(),
                previousYear = new Date(currentDate.setFullYear(currentDate.getFullYear() - 1)),
                filterDate = previousYear.getFullYear() +
                    "-" + (previousYear.getMonth() + 1) +
                    "-" + previousYear.getDate();

            self.dataLoaded = false;

            await this.$authManager.getUser(function (user) {
                self.$api.getQuestionnaireScores(self.questionnaire.id, filterDate, user).then(function (result) {
                    self.scoreChartData = {
                        id: self.questionnaire.id,
                        currentScore: self.questionnaire.score,
                        annualScores: result.annualQuestionnaireScores,
                        hasData: Object.keys(result.annualQuestionnaireScores).filter(function (key) {
                            return result.annualQuestionnaireScores[key] > 0;
                        }).length > 0
                    };
                    self.dataLoaded = true;
                });
            });
        },

        getDefaultScoreChartData() {
            let self = this,
                currentDate = new Date(),
                previousYear = new Date(currentDate.setFullYear(currentDate.getFullYear() - 1)),
                filterDate = previousYear.getFullYear() +
                    "-" + (previousYear.getMonth() + 1) +
                    "-" + previousYear.getDate(),
                result = {
                    id: self.questionnaire.id,
                    currentScore: self.questionnaire.score,
                    annualScores: {
                    },
                    hasData: false
                };

            result.annualScores[filterDate] = 300;

            return result;
        }
    }
}
